import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as Sentry from '@sentry/angular';
import { SentryService } from './sentry';
import { TraceService } from "@sentry/angular";
import { Router } from "@angular/router";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    SentryService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
  ],
})
export class SentryModule {
}
